import { Builder } from '../api/builder'
import { CommonResource, SearchResource } from "../api/config"

export const getCityInfo = Builder(city => SearchResource().get('/prepare', {params: {city: city}}))
export const decryptInfo = Builder(info => CommonResource().post('/decrypt', info))
export const getCommonDoc = Builder(() => CommonResource().get('/doc'))